import styled from "styled-components";

import Clickable from "../clickable";


export const TextExpandableStyled = styled.div`
`;

export const ClickableStyled = styled(Clickable)`
    margin-left: .5em;
`;